export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[Strona główna]]]').after('[[[Zmiana hasła]]]', [
        {
            name: '[[[Powiadomienia]]]',
            route: 'core-account-notifications',
            icon: 'bell'
        }
    ]);

    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').after('[[[Poczta wychodząca]]]', [
        {
            name: '[[[Powiadomienia]]]',
            route: 'notices-settings',
            icon: 'shield-alt',
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            auth: { all: ['NotificationsPermissions@Access'], any: [] }
        }
    ]);

    sitemap.find('[[[System]]]').after('[[[Administracja]]]', [
        {
            name: '[[[Centrum powiadomień]]]',
            icon: 'bell',
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            children: [
                {
                    name: '[[[Wysyłka wiadomości]]]',
                    route: 'core-notifications-broadcasting',
                    icon: 'clipboard-list',
                    namespace: 'Ideo.Core.Common.Application.Data.Core.CollectiveNotifications.Permissions',
                    auth: { all: ['CollectiveNotificationsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodaj wiadomość]]]',
                            route: 'core-notifications-broadcasting-add',
                            auth: { all: ['CollectiveNotificationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edytuj wiadomość]]]',
                            route: 'core-notifications-broadcasting-edit',
                            auth: { all: ['CollectiveNotificationsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Typy powiadomień]]]',
                    route: 'core-notifications-types',
                    icon: 'clipboard-list',
                    auth: { all: ['NotificationsPermissions@Access'], any: [] },
                    children: [
                        {
                            name: '[[[Edytuj komunikaty]]]',
                            route: 'core-notifications-types-edit',
                            auth: { all: ['NotificationsPermissions@Access'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Szablony email]]]',
                    route: 'core-notifications-templates',
                    icon: 'clipboard-list',
                    auth: { all: ['NotificationsPermissions@Access'], any: [] },
                    children: [
                        {
                            name: '[[[Dodaj szablon]]]',
                            route: 'core-notifications-templates-add',
                            auth: { all: ['NotificationsPermissions@Access'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edytuj szablon]]]',
                            route: 'core-notifications-templates-edit',
                            auth: { all: ['NotificationsPermissions@Access'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);
};
